<template>
  <AdjustLinkGeneratorCore />
</template>

<script>
import AdjustLinkGeneratorCore from './AdjustLinkGeneratorCore.vue'

export default {
  name: 'AdjustLinkGenerator',
  components: { AdjustLinkGeneratorCore },
}
</script>
